// Footer — site-wide chrome at the bottom of every page.
//
// For the standalone help portal we keep three columns: brand/tagline,
// knowledge base nav (so users can jump between guides), and contact
// details. No outbound marketing-site links.

import { Link } from 'react-router-dom';

interface InternalLink {
  to: string;
  label: string;
}

// ----- Knowledge Base internal nav -----
// Single source of truth — used in the footer (here) and on the home page.
// If you add a new guide, update both this list and IndexPage.tsx.
const KB_LINKS: InternalLink[] = [
  { to: '/',           label: 'All Guides' },
  { to: '/teacher',    label: "Teachers' Guide" },
  { to: '/parent',     label: "Parents' Guide" },
  { to: '/principal',  label: 'Principal Guide' },
  { to: '/accountant', label: 'Accountant Guide' },
  { to: '/hr',         label: 'HR & Payroll Guide' },
  { to: '/librarian',  label: 'Librarian Guide' },
  { to: '/transport',  label: 'Transport Guide' },
  { to: '/admissions', label: 'Admissions Guide' },
  { to: '/reception',  label: 'Visitor Desk Guide' },
  { to: '/counsellor', label: 'Counsellor Guide' },
  { to: '/admin',      label: 'Admin Guide' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner footer__inner--three-col">

        {/* Brand column */}
        <div className="footer__col footer__brand">
          <img src="/src/images/EduateLogo.svg" alt=""  style={{background:"white",padding:5}}/>
          <p>
            Step-by-step guides, tutorials, and answers for every role —
            from teachers and parents to administrators and operations
            staff.
          </p>
        </div>

        {/* Knowledge Base internal nav */}
        <div className="footer__col">
          <h5>Browse Guides</h5>
          <ul>
            {KB_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact info */}
        <div className="footer__col">
          <h5>Get in Touch</h5>
          <p>
            Infra House, Hennur-Bagalur Main Road,<br />
            Kalyan Nagar, Bengaluru 560043,<br />
            Karnataka, India
          </p>
          <p>
            <a href="mailto:info@myeduate.com">info@myeduate.com</a><br />
            <a href="tel:9844774400">(+91) 9844774400</a>
          </p>
        </div>

      </div>

      <div className="footer__bottom">
        © All Rights Reserved.
      </div>
    </footer>
  );
}
